// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"742639b4","751":"9b9a27ff"}[chunkId] + ".chunk.css";
};